import React from 'react'
import { OccPayload } from '../../lib/OccPayload';
import { format, startOfDay } from 'date-fns';
import { OccupancyMonthResponse } from '../../../../services/occupancy/response/OccupancyMonthResponse';

interface SlotLabelContentProps {
    info: any;
    occupancy: OccPayload[];
    occMonth?: OccupancyMonthResponse;
}

const convertDateToString = (date: Date): string => {
    const startOfDayDate = startOfDay(date);
    return format(startOfDayDate, 'yyyy-MM-dd');
};

const findOccupancy = (occupancy: OccPayload[], date: string) => {
    const targetData = occupancy.find((data) => {
        const formattedDate = convertDateToString(new Date(data.date));
        const formattedDate2 = convertDateToString(new Date(date));
        return formattedDate === formattedDate2;
    });

    if (targetData) {
        return targetData;
    }

    return null;
};

const SlotLabelContent: React.FC<SlotLabelContentProps> = ({ info, occupancy, occMonth }) => {
    if (info.level === 0) {
        if (!occMonth || !Array.isArray(occMonth.data)) {
            return <div className="text-primary">{info.text}</div>
        }

        const start = startOfDay(new Date(info.date));
        const month = start.getMonth();
        const year = start.getFullYear();
        const monthYearDate = `${year}-${String(month + 1).padStart(2, '0')}`;

        const monthYearData = occMonth.data.find((data) => data.month === monthYearDate);

        return <div
            className="d-flex justify-content-center align-items-center"
            style={{ gap: '0.25rem', fontSize: '.875rem' }}
        >
            <span className="text-primary">{info.text}</span>
            {monthYearData?.occupancy !== undefined ? (
                <span className="text-muted">{monthYearData.occupancy}%</span>
            ) : (
                <span className="text-muted placeholder-glow">
                    <span className="placeholder d-inline-block" style={{ width: '30px' }}></span>
                </span>
            )}
        </div>

    } else if (info.level === 1) {
        const occData = findOccupancy(occupancy, info.date);

        return (
            <div className='d-flex flex-column' style={{ fontSize: '0.625rem' }}>
                <span className='text-primary'>{info.text}</span>
                <span className='text-muted'>{occData?.occupancy}%</span>
            </div>
        )
    } else {
        return null;
    }
}

export default SlotLabelContent